/**
 * Return Authorization header if access_token exists.
 */
export const authHeader = () => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Unified response handler for fetch requests.
 * Returns JSON or text if response OK, otherwise throws a formatted Error.
 */
export const handleResponse = async (res, prefix = 'Request failed') => {
  if (res.ok) {
    if (res.status === 204) return null;
    const ct = res.headers.get('content-type') || '';
    return ct.includes('application/json') ? res.json() : res.text();
  }

  let msg;
  try {
    const body = await res.json();
    msg = body.detail || JSON.stringify(body);
  } catch {
    msg = res.statusText;
  }

  throw new Error(`${prefix}: ${msg}`);
};
